module.exports = __webpack_public_path__ + "static/media/jayco4.bea100c3.JPG";